import { Modal } from "antd"
import { useVoidInvoice } from "@mimber/client/mimber-organization"
import { message } from "@mimber/ui-web"

export const useVoidInvoiceModal = (
  invoiceUuid: string,
  onSuccess?: () => void
) => {
  const [modal, contextHolder] = Modal.useModal()
  const voidMutation = useVoidInvoice(invoiceUuid)

  const showVoidInvoiceModal = (): void => {
    modal.confirm({
      title: "Void Invoice",
      content:
        "Are you sure you want to void this invoice? This action cannot be undone.",
      okText: "Void Invoice",
      okType: "danger",
      cancelText: "Cancel",
      onOk: () =>
        new Promise<void>((resolve, reject) => {
          voidMutation.mutate(
            { voidReason: "Voided by admin" },
            {
              onSuccess: () => {
                message.success("Invoice voided")
                onSuccess?.()
                resolve()
              },
              onError: (error) => {
                message.error(`Failed to void invoice: ${error.message}`)
                reject()
              },
            }
          )
        }),
    })
  }

  return {
    contextHolder,
    showVoidInvoiceModal,
  }
}
